module.exports = __webpack_public_path__ + "img/Profile-6.01fb6a98.png";